var map = {
	"./comment_channel.js": "./app/frontend/channels/comment_channel.js",
	"./draft_channel.js": "./app/frontend/channels/draft_channel.js",
	"./hotwire_livereload_channel.js": "./app/frontend/channels/hotwire_livereload_channel.js",
	"./research_channel.js": "./app/frontend/channels/research_channel.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/frontend/channels sync recursive _channel\\.js$";